import { Route, Routes, Navigate } from "react-router-dom";
import AIInterview from "../pages/candidate/AIInterview";
import CandidateDashboard from "../pages/candidate/Dashboard";
import UsersProfile from "../pages/common/UsersProfile";
import Setting from "../pages/common/Setting";
import TestMCQ from "../pages/candidate/TestMCQ";
import TestCoding from "../pages/candidate/TestCoding";
import PracticalMcq from "../pages/candidate/PracticalMcq";
import PsycometricMcq from "../pages/candidate/PsycometricMcq";
import CandidateVideoCall from "../pages/candidate/CandidateVideoCall";
import VideoCall from "../pages/candidate/VideoCall";
const CandidateRoutes = () => {
  return (
    <Routes>
      <Route path="/candidate/dashboard" element={<CandidateDashboard />} />
      <Route path="/candidate/ai-interview" element={<AIInterview />} />
      <Route path="/candidate/mcq-test" element={<TestMCQ />} />
      <Route path="/candidate/coding-test" element={<TestCoding />} />
      <Route path="/candidate/ai" element={<AIInterview />} />
      <Route path="/candidate/profile" element={<UsersProfile />} />
      <Route path="/candidate/practical-test" element={<PracticalMcq />} />
      <Route path="/candidate/psycometric-test" element={<PsycometricMcq />} />
      <Route path="/candidate/setting" element={<Setting />} />
      {/* <Route path="/candidate/:roomId" element={<CandidateVideoCall />} /> */}
      <Route path="/meeting/:roomId" element={<VideoCall />} />
      <Route path="*" element={<Navigate to="candidate/dashboard" replace />} />
    </Routes>
  );
};

export default CandidateRoutes;
